interface GetEngineIdProps {
	daEngine: string;
	enEngine: string;
	klEngine: string;
	locale: 'da' | 'en' | 'kl-gl';
}

export const getEngineId = ({ daEngine, enEngine, klEngine, locale }: GetEngineIdProps): number => {
	const engines = {
		da: daEngine,
		en: enEngine,
		'kl-gl': klEngine,
	};
	return Number(engines[locale]) ?? null;
};
